export enum SubmitType {
	LOG_IN = 'login',
	REGISTER = 'register',
	CONFIRM = 'confirm',
	RESET_PASSWORD = 'reset-password',
}
